import React from 'react';
import ReactPlayer from 'react-player';

const DailyMotion = () => {
  return (
    <ReactPlayer
      controls={true}
      url='https://www.dailymotion.com/video/x5e9eog'
    />
  );
};

export default DailyMotion;
